import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface PropertyState {
	propertyId: string;
	propertyName: string;
	currencyCode: string;
	availableHistory?: boolean;
	physicalCap?: number;
}

const initialState: PropertyState = {
	propertyId: '',
	propertyName: '',
	currencyCode: 'USD',
	availableHistory: undefined, // Default to false if not provided
	physicalCap: undefined,
};

export const propertySlice = createSlice({
	name: 'property',
	initialState,
	reducers: {
		setProperty(state, action: PayloadAction<PropertyState>) {
			state.propertyId = action.payload.propertyId;
			state.propertyName = action.payload.propertyName;
			state.currencyCode = action.payload.currencyCode;
			state.availableHistory = action.payload.availableHistory;
			state.physicalCap = action.payload.physicalCap;
		},
	},
});

export const { setProperty } = propertySlice.actions;

export default propertySlice.reducer;
